import { Interval } from '@ui/constants/poll';
import { usePayTokenBalance } from '@ui/hooks/usePayTokenBalance';

import { useCollateralToken } from '../components/TradeModule/store/useCollateralToken';

export const useGetPayableTokenBalance = () => {
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());

  return usePayTokenBalance(payToken, Interval.FAST);
};
